import styled from "styled-components";

/**
 * Wrapper principal do conteúdo de busca
 */
export const ContentWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const SearchContentWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(4)};
  gap: ${({ theme }) => theme.spacing(2)};
  transform: translateY(calc(${({ theme }) => theme.spacing(-7)} - 10px));
  position: relative;
  z-index: 3;
  flex-direction: column;
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const RadioWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(3)};
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const DatasSearchWrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing(0.3)};
  padding-bottom: ${({ theme }) => theme.spacing(0.2)};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.spacing(10)};
  height: ${({ theme }) => theme.spacing(10)};
  justify-content: space-around;
  display: flex;
  flex: 1;

  & > div:not(:last-child) {
    flex: 1; /* Todos os filhos, exceto o último, terão o mesmo tamanho */
    max-width: 100%; /* Impede que ultrapassem os limites */
  }

  & > div:last-child {
    flex: 0; /* Ajusta-se ao tamanho necessário */
    white-space: nowrap; /* Garante que o conteúdo não quebre em múltiplas linhas */
  }

  & > div:first-child {
    padding-left: ${({ theme }) => theme.spacing(1)};
  }

  & > div:last-child {
    padding-right: ${({ theme }) => theme.spacing(1)};
  }
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const FieldSearchContent = styled.div`
  padding: ${({ theme }) => theme.spacing(0)};
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  position: relative;
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const FieldSearch = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  display: flex;
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const FieldSearchDropdown = styled.div`
  position: absolute;
  min-width: ${({ theme }) => theme.spacing(38)};
`;

/**
 * Wrapper principal do conteúdo de busca
 */
export const Divisor = styled.span`
  background-color: ${({ theme }) => theme.colors.lightGray};
  height: 100%;
  width: 1px;
`;
